import { render, staticRenderFns } from "./App.vue?vue&type=template&id=06536af0"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=06536af0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports